EMMY.bindEntryDetails = {
  init: function() {
    $('.program_title').on('keyup', function(e) {
      var programTitle = $(this).val();
      $('.entry-info_item.Program.Title .value').text(programTitle);
    });

    $('.national_network').on('change', function(e) {
      var networkTitle = $(this).val();
      $('.entry-info_item.Appeared.On .value').text(networkTitle);
    });

    $(document).on('click', '#modal-ok-contact-awards', function(e) {
      $('#unpaidModal').iziModal('close');
      $('.show-unpaid-modal').removeClass('show-unpaid-modal');
    });

  }
};